import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AUTH_HERO_IMAGES } from '../helpers/constants';

@Pipe({
  name: 'authHeroImage',
  pure: false,
})
export class AuthHeroImagePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(isMobile: boolean): string {
    if (isMobile) {
      return 'assets/images/companylogin.svg';
    }

    return this.translateService.currentLang === 'ro'
      ? AUTH_HERO_IMAGES.ro
      : AUTH_HERO_IMAGES.en;
  }
}
